import BaseModel from "models/BaseModel";

export default class CreditCheckRuleModel extends BaseModel {}
